import React from "react";
import CollapsibleSection from "./CollapsibleSection";

const PoliciesPanel = ({
  isOpen,
  onToggle,
  formData,
  setFormData,
}) => {
  return (
    <CollapsibleSection
      title="⚖️ Policies"
      isOpen={isOpen}
      onToggle={onToggle}
    >
      <div className="form-section">
        <small className="note">
          Use this space to list store policies, transfer/shipping rules, hours, or other key info customers should know.
        </small>

        {/* <details className="policy-block" open>
          <summary>⚖️ Store Policies</summary>
          <textarea
            name="policy_store"
            maxLength={1000}
            placeholder="Ex: All firearm sales are final. No returns on used inventory..."
            value={formData.policy_store || ""}
            onChange={(e) =>
              setFormData((prev) => ({ ...prev, policy_store: e.target.value }))
            }
          />
          <span className="description-counter">
            {formData.policy_store.length}/1000 characters
          </span>
        </details>

        <details className="policy-block">
          <summary>📦 Transfers & Shipping</summary>
          <textarea
            name="policy_shipping"
            maxLength={1500}
            placeholder="Ex: Incoming transfers: $25 per firearm. We only ship to verified FFLs..."
            value={formData.policy_shipping || ""}
            onChange={(e) =>
              setFormData((prev) => ({ ...prev, policy_shipping: e.target.value }))
            }
          />
          <span className="description-counter">
            {formData.policy_shipping.length}/1500 characters
          </span>
        </details>

        <details className="policy-block">
          <summary>📘 FAQs (Optional)</summary>
          <textarea
            name="policy_faq"
            maxLength={2000}
            placeholder="Ex: Q: Do you sell suppressors? A: Yes, NFA items available with proper paperwork."
            value={formData.policy_faq || ""}
            onChange={(e) =>
              setFormData((prev) => ({ ...prev, policy_faq: e.target.value }))
            }
          />
          <span className="description-counter">
            {formData.policy_faq.length}/2000 characters
          </span>
        </details> */}

        <div className="policy-block">
          <summary>⚖️ Store Policies</summary>
          <textarea
            name="policy_store"
            maxLength={1000}
            placeholder="Ex: All firearm sales are final. No returns on used inventory..."
            value={formData.policy_store || ""}
            onChange={(e) =>
              setFormData((prev) => ({ ...prev, policy_store: e.target.value }))
            }
          />
          <span className="description-counter">
            {formData.policy_store.length}/1000 characters
          </span>
        </div>

        <div className="policy-block">
          <summary>📦 Transfers & Shipping</summary>
          <textarea
            name="policy_shipping"
            maxLength={1500}
            placeholder="Ex: Incoming transfers: $25 per firearm. We only ship to verified FFLs..."
            value={formData.policy_shipping || ""}
            onChange={(e) =>
              setFormData((prev) => ({ ...prev, policy_shipping: e.target.value }))
            }
          />
          <span className="description-counter">
            {formData.policy_shipping.length}/1500 characters
          </span>
        </div>

        <div className="policy-block">
          <summary>📘 FAQs (Optional)</summary>
          <textarea
            name="policy_faq"
            maxLength={2000}
            placeholder="Ex: Q: Do you sell suppressors? A: Yes, NFA items available with proper paperwork."
            value={formData.policy_faq || ""}
            onChange={(e) =>
              setFormData((prev) => ({ ...prev, policy_faq: e.target.value }))
            }
          />
          <span className="description-counter">
            {formData.policy_faq.length}/2000 characters
          </span>
        </div>
      </div>
    </CollapsibleSection>
  );
};

export default PoliciesPanel;